import { render, staticRenderFns } from "./BldMess.vue?vue&type=template&id=f0a03502&scoped=true&"
import script from "./BldMess.vue?vue&type=script&lang=js&"
export * from "./BldMess.vue?vue&type=script&lang=js&"
import style0 from "./BldMess.vue?vue&type=style&index=0&id=f0a03502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a03502",
  null
  
)

export default component.exports